import { TextNode } from 'lexical';

export class RedactedNode extends TextNode {
  static getType() {
    return 'redacted';
  }

  static clone(node) {
    return new RedactedNode(node.__text, node.__originalText, node.__redactionId, node.__key);
  }

  constructor(text, originalText = text, redactionId = Math.random().toString(36).substr(2, 9), key) {
    super(text, key);
    this.__originalText = originalText;
    this.__redactionId = redactionId;
  }

  createDOM(config) {
    const element = super.createDOM(config);
    element.className = 'redacted-text';
    element.setAttribute('data-original', this.__originalText);
    element.setAttribute('data-redaction-id', this.__redactionId);
    element.setAttribute('data-lexical-redacted', 'true');
    
    element.textContent = [];
    element.style.cssText = 'background-color: #fff3e0; color: #f57c00; padding: 2px 4px; border-radius: 3px; font-weight: bold; border: 1px dashed #f57c00;';
    
    return element;
  }

  updateDOM(prevNode, dom) {
    const willUpdate = super.updateDOM(prevNode, dom);
    dom.setAttribute('data-original', this.__originalText);
    dom.setAttribute('data-redaction-id', this.__redactionId);
    dom.setAttribute('data-lexical-redacted', 'true');
    
    dom.textContent = [];
    dom.style.cssText = 'background-color: #fff3e0; color: #f57c00; padding: 2px 4px; border-radius: 3px; font-weight: bold; border: 1px dashed #f57c00;';
    
    return willUpdate;
  }

  getOriginalText() {
    return this.__originalText;
  }

  getRedactionId() {
    return this.__redactionId;
  }

  static importDOM() {
    return {
      span: (node) => {
        if (node.hasAttribute('data-lexical-redacted')) {
          return {
            conversion: (domNode) => {
              const originalText = domNode.getAttribute('data-original') || domNode.textContent;
              const redactionId = domNode.getAttribute('data-redaction-id') || Math.random().toString(36).substr(2, 9);
              return {
                node: $createRedactedNode('[REDACTED]', originalText, redactionId),
              };
            },
            priority: 1,
          };
        }
        return null;
      },
    };
  }

  static importJSON(serializedNode) {
    const { text, originalText, redactionId } = serializedNode;
    const node = $createRedactedNode(text, originalText, redactionId);
    node.setFormat(serializedNode.format);
    node.setDetail(serializedNode.detail);
    node.setMode(serializedNode.mode);
    node.setStyle(serializedNode.style);
    return node;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      originalText: this.__originalText,
      redactionId: this.__redactionId,
      type: 'redacted',
      version: 1,
    };
  }
}

export function $createRedactedNode(text, originalText, redactionId) {
  return new RedactedNode(text, originalText, redactionId);
}

export function $isRedactedNode(node) {
  return node instanceof RedactedNode;
}
